// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1L-26","rootCenter":"LoadMoreObserver_rootCenter__1ql_L","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__7KJZu"};